import { createSelector } from 'reselect';
import { selectGlobalDomain } from 'services/slices/global';

const makeSelectProjectPrivileges = createSelector(
  selectGlobalDomain,
  (subState) => subState.projectPrivileges,
);
export default makeSelectProjectPrivileges;
